export default __webpack_public_path__ + "static/media/footet-bottom.e0a808b2.jpg";